export function normalizeSriLankanWhatsAppNumber(value: string): string {
  const digits = value.replace(/\D/g, '');

  if (!digits) return '';
  if (digits.startsWith('94')) return digits;
  if (digits.startsWith('0') && digits.length === 10) return `94${digits.slice(1)}`;
  if (digits.length === 9) return `94${digits}`;

  return digits;
}

export function buildWhatsAppUrl(phoneNumber: string, message?: string): string {
  const normalized = normalizeSriLankanWhatsAppNumber(phoneNumber);
  const baseUrl = `https://wa.me/${normalized}`;

  if (!message) return baseUrl;
  return `${baseUrl}?text=${encodeURIComponent(message)}`;
}
